export const GET_STAFF = 'GET_STAFF';
export const GET_NEW_STAFF = 'GET_NEW_STAFF';
export const GET_TOTAL_STAFF = 'GET_TOTAL_STAFF';
